import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import useSageCustomers from '../CustomHooks/useSageCustomers';
const zeroOneOptions = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
  { value: '', label: 'Not Assessed' },
];
const yesNoOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
  { value: '', label: 'Not Assessed' },
];

let productsInputKeys = [
  {
    name: 'products',
    typeOfInp: 'select',
    label: 'Products',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    dropdownOptionsName: 'products',
    required: true,
  },
  {
    name: 'subCompartmentName',
    typeOfInp: 'select',
    label: 'Sub Compartment Name',
    isTextArea: false,
    width: 6,
    dropdownOptionsName: 'subCompartmentName',
    required: true,
  },
  // {
  //   name: 'productsLen',
  //   typeOfInp: 'input',
  //   label: 'Products Length',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   required: true,
  // },
  // {
  //   name: 'productsMinDia',
  //   typeOfInp: 'input',
  //   label: 'Products Min Diameter',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   required: true,
  // },
  {
    name: 'productsPercent',
    typeOfInp: 'input',
    label: 'Products Percent',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
    required: true,
  },
  {
    name: 'productsDestination',
    typeOfInp: 'select',
    label: 'Products Destination',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    dropdownOptionsName: 'destinations',
    required: true,
  },
  {
    name: 'customerName',
    typeOfInp: 'select',
    label: 'Customer Name',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    dropdownOptionsName: 'customer',
  },
  {
    name: 'productsPricePerTonne',
    typeOfInp: 'input',
    label: 'Price Per Tonne',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
    required: true,
  },
  // {
  //   name: 'price',
  //   typeOfInp: 'input',
  //   label: 'Price ',
  //   textFieldType: 'number',
  //   isTextArea: false,
  //   width: 4,
  //   required: true,
  // },
];
let speciesInputKeys = [
  {
    name: 'species',
    typeOfInp: 'select',
    label: 'Species',
    textFieldType: 'text',
    isTextArea: false,
    width: 12, // Full width row,
    dropdownOptionsName: 'species',
    required: true,
  },
  {
    name: 'subCompartmentName',
    typeOfInp: 'select',
    label: 'Sub Compartment Name',
    isTextArea: false,
    width: 6,
    dropdownOptionsName: 'subCompartmentName',
    required: true,
  },
  {
    name: 'areaInHa',
    typeOfInp: 'input',
    label: 'Area (Ha)',
    textFieldType: 'number',
    isTextArea: false,
    width: 6, // Half of the next row
    disabled: true,
  },
  {
    name: 'percentageOfSite',
    typeOfInp: 'input',
    label: 'Percentage of Site',
    textFieldType: 'number',
    isTextArea: false,
    width: 6, // Half of the next row
    required: true,
  },
];
const formatName = str => {
  if (!str) return;
  return str.charAt(0).toUpperCase() + (str.length >= 2 && str.slice(1));
};

const AddNewSectionInfo = ({ open, setOpen, sectionName, sectionData, handleNewAdd, dropDownOptions, subCompartments }) => {
  const [formData, setFormData] = useState({});
  const { getCustomerCode } = useSageCustomers();
  const handleChange = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };
  const handleClose = () => {
    setFormData({});
    setOpen(false);
  };

  const handleSave = e => {
    e.preventDefault();
    let payload = { ...formData };
    if (sectionName === 'products') {
      payload.customerCode = getCustomerCode(payload.customerName);
    }
    handleNewAdd({ ...formData }, sectionName);
  };
  useEffect(() => {
    if (open) {
      setFormData(sectionData);
    }
  }, [open]);

  const getInputArrayList = () => {
    if (sectionName === 'products') {
      return productsInputKeys;
    } else if (sectionName === 'species') {
      return speciesInputKeys;
    } else {
      return [];
    }
  };
  return (
    <Dialog disableAutoFocus disablePortal maxWidth="xl" open={open} onClose={handleClose} disableEscapeKeyDown={true}>
      <DialogTitle>
        <Typography style={{ fontSize: '1.5rem' }} component="div" variant="subtitle1">
          {' '}
          Add {formatName(sectionName)}
        </Typography>
      </DialogTitle>
      <form onSubmit={handleSave}>
        <DialogContent style={{ width: '60vw' }}>
          <Box
            noValidate
            component="div"
            className="SiteInfoDialog"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: '100%',
              gap: '1rem',
              height: '100%',
            }}>
            <Grid container spacing={5} style={{ height: 'max-content' }}>
              {getInputArrayList().map((inputProps, index) => (
                <Grid item xs={12} sm={6} md={inputProps.width || 4} key={`${inputProps.name}_${index}`}>
                  {inputProps.typeOfInp == 'select' && (
                    <TextField
                      variant="outlined"
                      required={inputProps.required}
                      select
                      fullWidth
                      size="small"
                      label={inputProps.label}
                      value={formData[inputProps.name] || ''}
                      disabled={inputProps.disabled}
                      onChange={e => handleChange(inputProps.name, e.target.value)}
                      SelectProps={{
                        MenuProps: {
                          disablePortal: true,
                          anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                          },
                          transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                          },
                          getContentAnchorEl: null, // only needed in older versions of MUI
                        },
                      }}>
                      {inputProps.name === 'subCompartmentName' && Array.isArray(subCompartments)
                        ? subCompartments.map(item => (
                            <MenuItem key={item.mapLabel} value={item.mapLabel}>
                              <Box display="flex" flexDirection="column">
                                <Typography variant="body1">{item.displayName}</Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {item.mapLabel}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ))
                        : inputProps.dropdownOptionsName &&
                          dropDownOptions[inputProps.dropdownOptionsName].map(menuItem => (
                            <MenuItem key={menuItem} value={menuItem}>
                              {menuItem}
                            </MenuItem>
                          ))}
                      {/* <MenuItem value="0">No</MenuItem>
                      <MenuItem value="">Not Assesed</MenuItem> */}
                    </TextField>
                  )}
                  {inputProps.typeOfInp == 'input' && (
                    <TextField
                      variant="outlined"
                      required={inputProps.required}
                      type={inputProps.textFieldType || 'text'}
                      fullWidth
                      size="small"
                      label={inputProps.label}
                      value={formData && formData[inputProps.name]}
                      disabled={inputProps.disabled}
                      onChange={e => handleChange(inputProps.name, e.target.value)}
                      multiline={inputProps.isTextArea}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}

                  {/* </FormControl> */}
                </Grid>
              ))}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddNewSectionInfo;
